/* eslint-disable */
import Cookies from 'js-cookie';
import cloneDeep from 'lodash/cloneDeep';
import { getHardWare, getSoftWare, jsonParser, removeSearchFromUrl } from './utils';

export default {
    /* 页面加载事件 */
    imgLog_PageLoad: function (logs) {
        try {
            if (!logs.web_pageid) throw new Error('web_pageid is required');

            this.imgLog({
                ...logs,
                web_buttonid: 'load',
            });
        } catch (e) {
            console.error(e);
        }
    },

    /* 按钮点击事件 */
    imgLog_Button: function (logs) {
        try {
            this.imgLog(logs);
        } catch (e) {
            console.error(e);
        }
    },

    /* 通用配置 */
    // prettier-ignore
    imgLog: function (obj) {
        if (Object.prototype.toString.call(obj) !== '[object Object]') {
            throw new TypeError('object is required');
        }

        const logs = cloneDeep(obj);
        logs['product_id'] = 'aw-login4abroadweb';
        logs['project_code'] = 'aw-login4abroadweb';
        logs['game_id'] = jsonParser(sessionStorage.getItem('appId') || localStorage.getItem('appId')) || '';
        logs['web_page_scene'] = this.getPlatform();
        logs['web_host'] = window.location.host;
        logs['user_agent'] = navigator.userAgent;
        logs['hardware_platform'] = getHardWare();
        logs['software_platform'] = getSoftWare();
        // logs['biz_appid'] = 791000412;

        /* 统计来源页 */
        const referrer = document.referrer;
        if (referrer && !referrer.includes(window.location.host)) {
            logs['web_referer'] = removeSearchFromUrl(referrer);
        } else {
            logs['web_referer'] = '';
        }

        this.imgLogPrivate(logs);
    },

    imgLogPrivate: function (params) {
        let img = new Image();
        let d = new Date();

        let event_time = this.fmtDate(d, 'yyyy-MM-dd hh:mm:ss');

        d.setHours(d.getHours(), d.getMinutes() - d.getTimezoneOffset());
        let timestamp = d.toISOString();
        timestamp = timestamp.substr(0, timestamp.length - 1) + '+08:00';

        let request_timestamp = timestamp;

        let local_timestamp = timestamp;

        let web_guidid = '';
        if (Cookies.get('web_guidid')) {
            web_guidid = Cookies.get('web_guidid');
        } else {
            web_guidid = this.traceId();
            Cookies.set('web_guidid', web_guidid, {
                secure: true,
                SameSite: 'None',
            });
        }

        let web_url = window.location.href;

        let point_id = (Array(6).join(0) + ((Math.random() * 1000000) >> 0)).slice(-6);

        let hardware_deviceid = '';

        let hardware_androidid = '';

        if (typeof window.USER !== 'undefined' && window.USER.getSystemInfo !== 'undefined') {
            const getSystemInfo = window.USER.getSystemInfo() || {};
            hardware_deviceid = getSystemInfo.getDeviceId() || '';
            hardware_androidid = getSystemInfo.getAndroidId() || '';
        }

        let realParams = {
            timestamp: timestamp,
            request_timestamp: request_timestamp,
            event_time: event_time,
            local_timestamp: local_timestamp,
            web_guidid: web_guidid,
            web_url: web_url,
            point_id: point_id,
            hardware_deviceid: hardware_deviceid,
            hardware_androidid: hardware_androidid,
        };
        Object.assign(realParams, params);
        let url =
            'https://reportsk-gg.web.sdo.com/report/ge/weblog?log=' +
            encodeURIComponent(JSON.stringify([realParams]));

        img.src = url;
    },

    /**
     *   对Date的扩展，将 Date 转化为指定格式的String
     *   月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
     *   年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
     *   例子：
     *   (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
     *   (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
     */
    fmtDate: function (date, fmt) {
        //author: meizz
        var o = {
            'M+': date.getMonth() + 1, //月份
            'd+': date.getDate(), //日
            'h+': date.getHours(), //小时
            'm+': date.getMinutes(), //分
            's+': date.getSeconds(), //秒
            'q+': Math.floor((date.getMonth() + 3) / 3), //季度
            S: date.getMilliseconds(), //毫秒
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp('(' + k + ')').test(fmt))
                fmt = fmt.replace(
                    RegExp.$1,
                    RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
                );
        return fmt;
    },
    getCookie: function (name) {
        var arr,
            reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');

        if ((arr = document.cookie.match(reg))) return decodeURIComponent(arr[2]);
        else return null;
    },
    setCookie: function (name, value, seconds) {
        seconds = seconds || 0; //seconds有值就直接赋值，没有为0
        var expires = '';
        if (seconds != 0) {
            //设置cookie生存时间
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = '; expires=' + date.toGMTString();
        }
        document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/'; //转码并赋值
    },
    traceIdNumber: function (num) {
        let seed = [
            [0, 2, 3, 5, 9, 8, 7, 1, 4, 6],
            [1, 4, 3, 8, 5, 7, 9, 0, 6, 2],
            [3, 4, 0, 9, 5, 8, 7, 6, 2, 1], //百
            [2, 9, 5, 3, 0, 8, 1, 7, 4, 6], //千
            [5, 3, 2, 0, 4, 8, 9, 1, 7, 6], //万
        ];

        if (!num) {
            num = Math.round(new Date().getTime() / 1000);

            seed = [
                [6, 9, 5, 3, 0, 8, 1, 7, 4, 2],
                [0, 2, 3, 5, 9, 8, 7, 1, 4, 6],
                [5, 3, 2, 0, 4, 8, 9, 1, 7, 6],
                [3, 4, 0, 9, 5, 8, 7, 6, 2, 1],
                [1, 4, 3, 8, 5, 7, 9, 0, 6, 2],
            ];
        }

        num = num.toString().split('').reverse().join('');

        let newNum = '';

        for (var i = 4; i >= 0; i--) {
            var n = '0';

            if (num[i] != undefined) {
                n = num[i];
            }

            newNum += seed[i][n];
        }

        return newNum;
    },
    traceId: function () {
        let traceId = '';

        let beginDate = new Date('2015-01-01');
        let today = new Date();

        let daysSpan = Math.round((today.getTime() - beginDate.getTime()) / 86400000).toString();

        traceId =
            this.traceIdNumber(daysSpan) + this.traceIdNumber() + Math.round(today.getTime() % 10);

        return traceId;
    },
    // prettier-ignore
    getPlatform() {
        const platform = jsonParser(sessionStorage.getItem('platform') || localStorage.getItem('platform')) || '';
        switch (platform) {
            case 1:
            case 5:
                return 'H5';
            case 2:
                return 'iframe';
            case 3:
            case 6:
                return 'WebView';
            case 4:
                return 'Android';
            default:
                return '';
        }
    },
};
